import {Point} from "@node-editor/types/navigation"

// create a transformation matrix that both translates and scales, fixing the origin point
export const translateAndScale = (translation: Point, scale: number, origin: Point) => {
    return new DOMMatrix()
        .translate(translation.x || 0, translation.y || 0)
        .translate(origin.x, origin.y)
        .scale(scale || 1)
        .translate(-origin.x, -origin.y)
}

// offset a position by an element's location on the screen
export const screenToElementCoordinates = (relativeTo: HTMLElement, point: {x: number; y: number}) => {
    const rect = relativeTo.getBoundingClientRect()
    return {
        x: point.x - rect.x,
        y: point.y - rect.y,
    }
}

export const elementToScreenCoordinates = (child: HTMLElement, point: {x: number; y: number}) => {
    const rect = child.getBoundingClientRect()
    return {
        x: point.x + rect.x,
        y: point.y + rect.y,
    }
}
